/**
 * FeelX — Adaugare / eliminare automata a produsului cadou
 * Foloseste pub/sub-ul din Dawn (PUB_SUB_EVENTS.cartUpdate).
 * Configurare: Theme settings > FeelX.
 */
(function () {
  'use strict';

  var inLucru = false;
  var ultimulTotal = null;

  function config() {
    var el = document.querySelector('[data-feelx-progress]');
    if (!el) return null;
    var variantId = parseInt(el.dataset.variantCadou, 10);
    if (el.dataset.cadouActiv !== 'true' || !variantId) return null;
    return {
      prag: parseInt(el.dataset.prag, 10),
      variantId: variantId,
    };
  }

  function citesteCos() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      credentials: 'same-origin',
    }).then(function (r) {
      return r.json();
    });
  }

  function sectiuniDeRandat() {
    var lista = [];
    if (document.getElementById('CartDrawer')) lista.push('cart-drawer', 'cart-icon-bubble');
    if (document.getElementById('main-cart-items')) lista.push('main-cart-items', 'main-cart-footer', 'cart-icon-bubble');
    return lista;
  }

  function reincarcaSectiuni() {
    var sectiuni = sectiuniDeRandat();
    if (!sectiuni.length) return Promise.resolve();

    return fetch(window.location.pathname + '?sections=' + sectiuni.join(','))
      .then(function (r) {
        return r.json();
      })
      .then(function (date) {
        sectiuni.forEach(function (nume) {
          if (!date[nume]) return;
          var sursa = new DOMParser().parseFromString(date[nume], 'text/html');
          var tinta = document.getElementById(nume) || document.getElementById('CartDrawer');
          if (nume === 'cart-icon-bubble') {
            var bubble = document.getElementById('cart-icon-bubble');
            var bubbleNou = sursa.getElementById('shopify-section-cart-icon-bubble');
            if (bubble && bubbleNou) bubble.innerHTML = bubbleNou.innerHTML;
            return;
          }
          var sectiuneNoua = sursa.getElementById('shopify-section-' + nume);
          var sectiuneVeche = document.getElementById('shopify-section-' + nume);
          if (sectiuneNoua && sectiuneVeche) {
            sectiuneVeche.innerHTML = sectiuneNoua.innerHTML;
          }
        });
      })
      .catch(function (e) {
        console.error('FeelX gift — re-randare:', e);
      });
  }

  function modificaCos(corp) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corp),
    });
  }

  function adaugaCadou(variantId) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _cadou: 'da' } }],
      }),
    });
  }

  function sincronizeaza() {
    var cfg = config();
    if (!cfg || inLucru) return;
    inLucru = true;

    citesteCos()
      .then(function (cos) {
        var cadou = cos.items.find(function (item) {
          return item.variant_id === cfg.variantId;
        });

        var total = cos.items.reduce(function (suma, item) {
          if (item.variant_id === cfg.variantId) return suma;
          return suma + item.final_line_price;
        }, 0);

        if (total === ultimulTotal && !(cadou && cadou.quantity > 1)) {
          return null;
        }
        ultimulTotal = total;

        if (total >= cfg.prag && !cadou) {
          return adaugaCadou(cfg.variantId).then(reincarcaSectiuni);
        }
        if ((total < cfg.prag || cos.item_count === 1) && cadou) {
          return modificaCos({ id: cadou.key, quantity: 0 }).then(reincarcaSectiuni);
        }
        if (cadou && cadou.quantity > 1) {
          return modificaCos({ id: cadou.key, quantity: 1 }).then(reincarcaSectiuni);
        }
        return null;
      })
      .catch(function (e) {
        console.error('FeelX gift:', e);
      })
      .then(function () {
        inLucru = false;
      });
  }

  function porneste() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(sincronizeaza, 100);
      });
    }
    document.addEventListener('cart:refresh', function () {
      setTimeout(sincronizeaza, 100);
    });
    sincronizeaza();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', porneste);
  } else {
    porneste();
  }
})();
